<script>
export default {};
</script>

<template>
	<router-view />
</template>

<style>
html {
	scroll-behavior: smooth;
}
body {
	overflow-x: hidden;
	background-color: #21282a;
	color: #d3d3d3;
	margin: 0;
}
#app {
	font-family: 'GeneralSans-Regular', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
</style>
